import miyaMiyaCertificate from 'images/certificate_without_data_gold_miyamiya.png';
import { type StreamForStreamDashboard } from 'Lessons';
import { getCertificateImageSrc } from '../selectors';
import { useIsMiyaMiya } from './useIsMiyaMiya';

// MiyaMiya students get the bundled gold badge, not their own certificate.
export function useCertificateImageSrc(stream: StreamForStreamDashboard) {
    const isMiyaMiya = useIsMiyaMiya();
    return isMiyaMiya ? miyaMiyaCertificate : getCertificateImageSrc(stream);
}
